// extracted by mini-css-extract-plugin
export var headline = "HowToAccessSlider-module--headline--xcCkp";
export var items = "HowToAccessSlider-module--items--ei+Is";
export var list = "HowToAccessSlider-module--list--Vz7aB";
export var nav = "HowToAccessSlider-module--nav--sr9+5";
export var navItem = "HowToAccessSlider-module--nav-item--yXs4G";
export var step = "HowToAccessSlider-module--step--u1zao";
export var wrapper = "HowToAccessSlider-module--wrapper--9Vd6u";